import { Button, Space } from "antd";
import { useTranslation } from "react-i18next";

export default function LanguageSwitch({ align = "right" }) {
  const { i18n } = useTranslation();
  const current = i18n.language;

  return (
    <div
      style={{
        position: "absolute",
        top: 16,
        right: align === "right" ? 16 : "auto",
        left: align === "left" ? 16 : "auto",
        zIndex: 10,
      }}
    >
      <Space size={4}>
        <Button
          size="small"
          type={current === "ja" ? "primary" : "text"}
          onClick={() => i18n.changeLanguage("ja")}
        >
          日本語
        </Button>
        <Button
          size="small"
          type={current === "en" ? "primary" : "text"}
          onClick={() => i18n.changeLanguage("en")}
        >
          English
        </Button>
      </Space>
    </div>
  );
}
